var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServicesBb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 5.5C3 3.57 4.52 2 6.4 2h11.2A3.45 3.45 0 0 1 21 5.5m-18 0C3 7.44 4.52 9 6.4 9h11.2A3.45 3.45 0 0 0 21 5.5m-18 0v12.9C3 21.31 4.52 22 6.4 22h11.2c1.88 0 3.4-.7 3.4-3.61V5.5M9 6v0c0-1.1.9-2 2-2h2.17a2 2 0 0 1 2 2v0M9.75 9v.75m5-.75v.75m-5 0V10c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-.25m-5 0h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 14.44 2.37.49 1.43-2.43 2.09 1.74L16 12.9l-.01 4.44-6.44 1.15L8 14.44Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesBb);
export default __webpack_public_path__ + "static/media/services_bb.14a8ecae5b3ed289a3fdf49670990890.svg";
export { ForwardRef as ReactComponent };